export var firebaseConfig = {
  apiKey: "AIzaSyAT1zzYPJGoMcHpQirNr-0NK-n_sk1iPIY",
  authDomain: "ecommerce-app-bf313.firebaseapp.com",
  databaseURL: "https://ecommerce-app-bf313.firebaseio.com",
  projectId: "ecommerce-app-bf313",
  storageBucket: "ecommerce-app-bf313.appspot.com",
  messagingSenderId: "987698654671",
  appId: "1:987698654671:web:c5e7a104ac64582b33f6ba",
  measurementId: "G-8WZ5339T1S"
};